/**
 * Rillion Prime API v1.0
 * A REST API endpoint for System operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type RowStates = 0 | 1 | 2 | 3;

export const RowStates = {
  NUMBER_0: 0 as RowStates,
  NUMBER_1: 1 as RowStates,
  NUMBER_2: 2 as RowStates,
  NUMBER_3: 3 as RowStates,
};
